import { create } from "apisauce";
import { responseUnnestData } from "./transformers";

export function createApi(settings = {}) {
  const api = create({ baseURL: process.env.REACT_APP_APIURL });

  /**
   * Custom Header Methods
   **/
  api.setAuthToken = token => {
    api.setHeader("Authorization", `Bearer ${token}`);
  };

  /**
   * Response Transforms
   **/
  api.addResponseTransform(responseUnnestData);

  return api;
}



// WEBPACK FOOTER //
// ./src/services/api/index.js